import type { Market } from '@/libs/sdk/api';

export type EventMarketGroup = {
  eventId: string;
  markets: Market[];
};

export const groupMarketsByEvent = (markets: Market[]): EventMarketGroup[] => {
  const groups = new Map<string, Market[]>();

  for (const market of markets) {
    const eventId = market.eventId || market.marketAddress;
    const current = groups.get(eventId);
    if (current) {
      current.push(market);
      continue;
    }
    groups.set(eventId, [market]);
  }

  return Array.from(groups.entries()).map(([eventId, groupedMarkets]) => ({
    eventId,
    markets: groupedMarkets,
  }));
};
